module.exports = __webpack_public_path__ + "static/media/subway.d006fda0.svg";